import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a warning icon
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WarningIcon width={12} />
 */
const WarningIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M22.12,20.47C21.94,20.8,21.58,21,21.2,21H2.8c-0.38,0-0.74-0.2-0.92-0.53s-0.18-0.73,0.01-1.06l9.2-15.88
            C11.28,3.2,11.63,3,12,3s0.72,0.2,0.92,0.53l9.2,15.88C22.31,19.74,22.31,20.15,22.12,20.47z M13,16h-2v2h2V16z M13,11
            c0-0.55-0.45-1-1-1l0,0c-0.55,0-1,0.45-1,1v2c0,0.55,0.45,1,1,1l0,0c0.55,0,1-0.45,1-1V11z`}
        />
    </SvgIcon>
)

WarningIcon.defaultProps = defaultProps

export { WarningIcon }
